import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  headingTitle: {
    id: 'course-authoring.certificates.heading.title',
    defaultMessage: 'Certificates',
  },
  headingTitleTabText: {
    id: 'course-authoring.certificates.heading.title.tab.text',
    defaultMessage: 'Course certificates',
  },
  headingSubtitle: {
    id: 'course-authoring.certificates.heading.subtitle',
    defaultMessage: 'Settings',
  },
  headingActionsPreview: {
    id: 'course-authoring.certificates.heading.action.button.preview',
    defaultMessage: 'Preview certificate',
  },
  headingActionsDeactivate: {
    id: 'course-authoring.certificates.heading.action.button.deactivate',
    defaultMessage: 'Deactivate',
  },
  headingActionsActivate: {
    id: 'course-authoring.certificates.heading.action.button.activate',
    defaultMessage: 'Activate',
  },
  noCertificatesText: {
    id: 'course-authoring.certificates.nocertificate.text',
    defaultMessage: 'You haven\'t added any certificates to this course yet.',
  },
  setupCertificateBtn: {
    id: 'course-authoring.certificates.setup.certificate.button',
    defaultMessage: 'Add your first certificate',
  },
  withoutModesText: {
    id: 'course-authoring.certificates.without.modes.text',
    defaultMessage: 'This course does not use a mode that offers certificates.',
  },
  cardCreate: {
    id: 'course-authoring.certificates.create',
    defaultMessage: 'Create',
  },
  cardCancel: {
    id: 'course-authoring.certificates.cancel',
    defaultMessage: 'Cancel',
  },
  deleteTooltip: {
    id: 'course-authoring.certificates.signatories.delete.tooltip',
    defaultMessage: 'Delete',
  },
  editTooltip: {
    id: 'course-authoring.certificates.signatories.edit.tooltip',
    defaultMessage: 'Edit',
  },
  saveTooltip: {
    id: 'course-authoring.certificates.signatories.save.tooltip',
    defaultMessage: 'Save',
  },
});

export default messages;
